import React from 'react';
import PropTypes from 'prop-types';
import { FieldLabel } from '../DisplayField/FieldLabel';

const FormikLabel = props => {
    const { fieldName, title, labelClassName } = props;
    return (
        <label htmlFor={fieldName} className={labelClassName}>
            <FieldLabel>{title || fieldName}</FieldLabel>
        </label>
    );
};

FormikLabel.propTypes = {
    formName: PropTypes.string,
    fieldName: PropTypes.string.isRequired
};

export default FormikLabel;
